import React from "react";
// import {
// 	DropletIcon,
// 	LandmarkIcon,
// 	WavesIcon,
// 	FlameIcon,
// 	SnowflakeIcon,
// 	RulerIcon,
// 	CircleDotIcon,
// 	GaugeCircle,
// 	DatabaseIcon,
// 	AlertTriangleIcon,
// 	CircleIcon,
// } from "lucide-react";
import { structureType } from "@/config/structureType";

interface StructureTypeIconProps {
	typeId: Dryp.StructureTypeId;
	showLabel?: boolean;
	showIndicator?: boolean;
	className?: string;
	size?: number;
}

// const typeIcons: Record<string, React.ElementType> = {
// 	"0": DropletIcon,
// 	"1": WavesIcon,
// 	"2": LandmarkIcon,
// 	"3": FlameIcon,
// 	"5": CircleDotIcon,
// 	"6": SnowflakeIcon,
// 	"7": GaugeCircle,
// 	"8": CircleIcon,
// 	"9": RulerIcon,
// 	"11": RulerIcon,
// 	"12": DatabaseIcon,
// 	"13": GaugeCircle,
// 	"14": AlertTriangleIcon,
// 	"15": AlertTriangleIcon,
// 	"16": WavesIcon,
// 	"999": CircleIcon,
// 	"1000": AlertTriangleIcon,
// 	"2000": WavesIcon,
// };

export const StructureTypeIcon: React.FC<StructureTypeIconProps> = ({
	typeId,
	showLabel = false,
	showIndicator = true,
	className = "",
	size = 18,
}) => {
	const config = structureType[typeId];
	if (!config) return null;

	// const Icon = typeIcons[typeId as unknown as string] ?? CircleIcon;

	return (
		<div className={`flex items-center gap-2 ${className}`}>
			{showIndicator && (
				<span
					className="inline-flex items-center justify-center rounded-full"
					style={{
						backgroundColor: config.bgColor,
						width: size,
						height: size,
					}}
				>
					{/* <Icon size={Math.max(size - 6, 10)} style={{ color: config.textColor }} /> */}
				</span>
			)}
			{showLabel && <span>{config.label}</span>}
		</div>
	);
};
